module.exports = __webpack_public_path__ + "static/media/terms.b47f9a27.txt";